<template>
  <div>
    <div v-for="(item, index) in data" :key="index">
      <div class="border-t border-gray-300 p-4 pl-2">
        <input
          class="hidden"
          type="checkbox"
          :value="index"
          v-model="checked"
          :id="item.title + '-' + index"
        />
        <div id class="flex head justify-between">
          <label
            :for="item.title + '-' + index"
            class="text-lg text-gray-700 flex w-full justify-between transition-colors duration-150 ease-in-out cursor-pointer hover:text-teal-500 font-medium"
          >
            {{ item.title }}
            <p class="text-gray-400 pl-3" v-if="checked.includes(index)">-</p>
            <p class="text-gray-400 pl-3" v-else>+</p>
          </label>
        </div>
        <p
          v-if="checked.includes(index)"
          class="pt-3 pr-6 mb-3"
        >{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    data: Array,
  },
  data() {
    return {
      checked: [],
    }
  },
}
</script>
